class ClientSelect {

    constructor($rootScope) {

        this.$rootScope = $rootScope;

        return {
            restrict: 'E',
            template: '<select class="pull-right form-control client-select" ng-model="selectedClientId" ng-options="c.id as c.name for c in clients"></select>',
            scope: {
                showWildcard: "@"
            },
            controller: ($scope, ApiService, CONTENT_TYPE, EVENTS) => {

                this.CONTENT_TYPE = CONTENT_TYPE;
                this.ApiService = ApiService;

                $scope.canShowWildcard = ($scope.showWildcard || "false") === "true";

                if(!$scope.canShowWildcard && $rootScope.currentUser.selectedClientId === "*") {
                    $rootScope.currentUser.selectedClientId = $rootScope.currentUser.clientId;
                }

                $scope.selectedClientId = $rootScope.currentUser.selectedClientId;

                $rootScope.$watch("currentUser.selectedClientId", () => {
                    $scope.selectedClientId = $rootScope.currentUser.selectedClientId;
                });

                $scope.$watch("selectedClientId", (newval) => {
                    $rootScope.currentUser.selectedClientId = $scope.selectedClientId;
                });

                this.loadClients($scope);

            }
        };

    }

    loadClients($scope) {

        this.ApiService.list(this.CONTENT_TYPE.CLIENT, '')
            .then(response => {

                let clients = response.data.sort( (a, b) => a.name.localeCompare(b.name) );
                if($scope.canShowWildcard && clients.length > 1) {
                    clients.unshift({id: "*", name: "All clients"});
                }

                $scope.clients = clients.map( (c) => { 
                    return { id: c.id.toString(), name: c.name };
                });

            });

    }

}


angular.module('cpm')
    .directive('clientSelect', ['$rootScope', ($rootScope) => {
        'use strict';
        return new ClientSelect($rootScope);
    }]);
